import React from "react";

const WeatherDetails = () => {
  return (
    <section>
      <p>Weather Details menu</p>
    </section>
  );
};

export default WeatherDetails;
